const coverStatus = {
  cancelled: 'Cancelled',
  lapsed: 'Lapsed',
  expired: 'Expired',
  starting: 'Confirmed',
  active: 'Live',
  reinstated: 'Reinstated',
};
export default coverStatus;
